// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Gj8d","footer":"styles_footer__2Cw0s","passCodeTooltip":"styles_passCodeTooltip__3DKGM"};